import styled from 'styled-components';

import prize1 from '@assets/images/promotions/place1.webp';
import prize2 from '@assets/images/promotions/place2.webp';
import prize3 from '@assets/images/promotions/place3.webp';

export const Wrapper = styled.div<{ $place: number }>`
	padding: 18px 16px;
	background-color: ${({ theme }) => theme.colors.background.secondary};
	border-radius: 12px;

	position: relative;

	background-image: url('${({ $place }) => ($place === 1 ? prize1 : $place === 2 ? prize2 : prize3)}');
	background-position: right;
	background-size: cover;
`;

export const Description = styled.div`
	font-size: 16px;
	line-height: 22px;
	font-weight: 400;
	color: ${({ theme }) => theme.colors.text.subtitle};

	margin-bottom: 4px;

	@media (max-width: 992px) {
		font-size: 14px;
		line-height: 19px;
	}
`;

export const MainText = styled.div`
	font-size: 18px;
	line-height: 25px;
	font-weight: 600;
	color: ${({ theme }) => theme.colors.text.title};

	margin-bottom: 8px;

	display: flex;
	align-items: center;
	gap: 6px;

	&:last-child {
		margin-bottom: 0;
	}

	@media (max-width: 992px) {
		font-size: 16px;
		line-height: 22px;
	}
`;

export const CupIconWrapper = styled.div`
	width: 20px;
	height: 20px;

	path {
		width: 20px;
		height: 20px;
		fill: ${({ theme }) => theme.colors.icon.main};
	}
`;
